export default __webpack_public_path__ + "7bbdb4ab6d58f6b223825aa2116257fe.svg";